export default "__VITE_ASSET__CZdJiGBl__"